import { tooltipConverter } from '../helpers';
import { PROVIDER_OPTION } from '../constants';
import { COLORS, FONT_FAMILY } from '../../../../constants/styles';

const { NAME } = PROVIDER_OPTION;

export const TOOLTIP = {
  backgroundColor: COLORS.white,
  displayColors: false,
  titleFontColor: COLORS.grayDark,
  footerFontColor: COLORS.grayDark,
  bodyFontColor: COLORS.grayDark,
  titleFontSize: 16,
  footerFontSize: 11,
  bodyFontSize: 11,
  bodyFontFamily: FONT_FAMILY.primary,
  titleFontFamily: FONT_FAMILY.primary,
  footerFontFamily: FONT_FAMILY.primary,
  titleFontStyle: 'bold',
  labelFontStyle: 'normal',
  footerFontStyle: 'normal',
  titleMarginBottom: 6,
  footerMarginTop: 6,
  xPadding: 12,
  yPadding: 12,
  borderColor: 'rgba(39, 45, 57, 0.05)',
  cornerRadius: 5,
  borderWidth: 1,
  shadowOffsetX: 0,
  shadowOffsetY: 2,
  shadowBlur: 10,
  shadowColor: 'rgba(39, 45, 57, 0.15)',
  xAlign: 'center',
  yAlign: 'bottom',
  callbacks: {
    title(points, { customOptions, datasets }) {
      const {
        type,
        metric,
        shortMetric,
        shouldConvertToFahrenheit,
      } = customOptions;
      return tooltipConverter.getValue({
        points,
        type,
        metric,
        datasets,
        shortMetric,
        shouldConvertToFahrenheit,
      });
    },
    label() {
      return null;
    },
    afterBody(point, { customOptions }) {
      const { period } = customOptions;
      return tooltipConverter.getDate({
        datePoint: point[0] && point[0].label,
        period,
      });
    },
    footer(points, { datasets, customOptions }) {
      const { providers } = customOptions;

      const { datasetIndex } = points[0];
      const dataset = datasetIndex ? datasets[datasetIndex] : datasets[0];
      const providerCode = dataset.label.split('.')[0];

      return providers[providerCode][NAME];
    },
  },
  custom: tooltip => {
    if (!tooltip.dataPoints) return;
    const y = Math.min(...tooltip.dataPoints.map(point => point.y));
    const { height, yPadding } = tooltip;
    // eslint-disable-next-line no-param-reassign
    tooltip.y = y - height - yPadding - 5;
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/options/tooltip.js